import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/gameonz/Home.vue";
import DetailPage from "@/components/gameonz/DetailPage.vue";
import Profile from "@/components/gameonz/Profile.vue";
import Subcategory from "@/components/gameonz/Subcategory.vue";
import HotPicks from "@/components/gameonz/HotPicks.vue";
import Popular from "@/components/gameonz/Popular.vue";
import Unsubscription from "@/components/gameonz/Unsubscription.vue"
import Login from "@/components/authentication/gameonz/Login.vue";
import Feedback from "../components/gameonz/Feedback.vue";
import PrivacyPolicy from "../components/gameonz/PrivacyPolicy.vue";
Vue.use(Router);

export default new Router({
  mode: "history",
  hash: false,
  history: true,
  routes: [
    {
      path: "/home",
      name: "Home",
      component: Home,
      children: [
        {
          path: "/home/:token"
        }
      ]
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      children: [
        {
          path: "/logout"
        }
      ]
    },
    {
      path: "/detail/:id",
      name: "DetailPage",
      component: DetailPage,
      children: [
        {
          path: "/detail/:id/:token"
        }
      ]
    },
    {
      path: "/profile",
      name: "Profile",
      component: Profile,
      children: [
        {
          path: "/profile/:token"
        }
      ]
    },
    {
      path: "/hotpicks",
      name: "HotPicks",
      component: HotPicks,
      children: [
        {
          path: "/hotpicks/:token"
        }
      ]
    },
    {
      path: "/popular",
      name: "Popular",
      component: Popular,
      children: [
        {
          path: "/popular/:token"
        }
      ]
    },
    {
      path: "/subcategory/:subcategory",
      name: "Subcategory",
      component: Subcategory,
      children: [
        {
          path: "/subcategory/:subcategory/:token"
        }
      ]
    },
    {
      path: "/feedback",
      name: "Feedback",
      component: Feedback,
      children: [
        {
          path: "/feedback/:token"
        }
      ]
    },
    {
      path: "/privacy",
      name: "PrivacyPolicy",
      component: PrivacyPolicy,
      children: [
        {
          path: "/privacy/:token"
        }
      ]
    },
    {
      path: "/unsubscription",
      name: "Unsubscription",
      component: Unsubscription
    },
    {
      path: '/:token',
      name: 'Home',
      component: Home
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/gameonz.js